import * as React from 'react';
import * as Datetime from 'react-datetime';
import * as Moment from 'moment-timezone';
import classes from 'classnames';
import SetDateButtons from './SetDateButtons';
import AdjustDateButtons from './AdjustDateButtons';
import { isWorkdayCalculationSupported, isWorkday } from './specialDays';
import TimezoneSelector from './TimezoneSelector';
import * as Utils from '../Utils';

interface ITimeInputProps {
  id: string;
  label: string;
  value: Date;
  tz: string;
  onChange: (date: Date) => void;
  onTzChange: (tz: string) => void;
}

interface ITimeInputState {
  error: boolean;
}

export default class TimeInput extends React.Component<ITimeInputProps, ITimeInputState> {

  constructor(props: ITimeInputProps) {
    super(props);
    this.state = {
      error: false,
    }
    this.onChange = this.onChange.bind(this);
    this.setDate = this.setDate.bind(this);
  }

  public render() {
    const m = Moment(this.props.value).tz(this.props.tz);
    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor={this.props.id}>{this.props.label}</label>
              <div className="input-group">
                <Datetime
                  value={this.props.value}
                  locale="en"
                  dateFormat={Utils.DATE_FORMAT}
                  timeFormat={Utils.TIME_FORMAT}
                  onChange={this.onChange}
                  inputProps={{
                    id: this.props.id,
                    className: classes('form-control', 'no-right-radius', {
                      'is-invalid': this.state.error
                    }),
                    title: "You can paste Unix timestamp"
                  }}
                  displayTimeZone={this.props.tz}
                />
                <div className="input-group-append">
                  <TimezoneSelector tz={this.props.tz} onChange={this.props.onTzChange} />
                </div>
              </div>
              <small className="form-text text-muted">
                {m.format('dddd')}
                {' - '}
                {isWorkdayCalculationSupported(m) ?
                  isWorkday(m) ?
                    'working day -'
                    :
                    'not working day -'
                  : null}
                {' Unix timestamp: '}
                {m.unix()}
                {' s'}
              </small>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SetDateButtons date={this.props.value} setDate={this.setDate} tz={this.props.tz}/>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <AdjustDateButtons date={this.props.value} setDate={this.setDate} tz={this.props.tz}/>
          </div>
        </div>
      </div>
    );
  }

  public onChange(value: string | Moment.Moment) {
    if (typeof value === "string") {
      const parsed = Number(value);
      let parsedValue;
      if (!isNaN(parsed)) {
        if (parsed >= 31536000000 && parsed < 2461449600000) {
          parsedValue = Moment(parsed);
        } else if (parsed >= 0 && parsed < 31536000000) {
          parsedValue = Moment.unix(parsed);
        }
      }
      if (parsedValue) {
        this.setDate(parsedValue);
      } else {
        this.setState({
          error: true
        });
      }
    } else {
      this.setDate(value);
    }
  }

  public setDate(newDate: Moment.Moment) {
    this.setState({
      error: false
    });
    this.props.onChange(newDate.toDate());
  }

}



// WEBPACK FOOTER //
// ./src/Calculator/TimeInput.tsx